import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import { Hr } from "@saleor/components/Hr";
import Skeleton from "@saleor/components/Skeleton";
import {
  Timeline,
  TimelineEvent,
  TimelineNote,
  TimelineNoteRemittanceProcessing
} from "@saleor/components/Timeline";
import { GetRemittance_remittance_remittanceEvents } from "@saleor/remittanceRunner/types/GetRemittance";
import { RemittanceEventTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { IntlShape, useIntl } from "react-intl";

export interface RemittanceRunnerHistoryProps {
  events: GetRemittance_remittance_remittanceEvents[];
}

const getEventMessage = (
  event: GetRemittance_remittance_remittanceEvents,
  intl: IntlShape
) => {
  switch (event.type) {
    case RemittanceEventTypeEnum.TO_REMIT:
      return intl.formatMessage({
        defaultMessage: "Remittance In-Progress",
        description: "remittance history message"
      });
    case RemittanceEventTypeEnum.REMITTED:
      return intl.formatMessage({
        defaultMessage: "Remitted",
        description: "remittance history message"
      });
    case RemittanceEventTypeEnum.PROCESSING:
      return intl.formatMessage({
        defaultMessage: "Awaiting Confirmation",
        description: "remittance history message"
      });
  }
};

const RemittanceRunnerHistory: React.FC<RemittanceRunnerHistoryProps> = props => {
  const { events } = props;
  const intl = useIntl();
  const eventsWithMessage = [
    RemittanceEventTypeEnum.TO_REMIT,
    RemittanceEventTypeEnum.REMITTED,
    RemittanceEventTypeEnum.PROCESSING
  ];

  return (
    <Card>
      <CardTitle title="History" />
      <CardContent>
        <Timeline>
          {events ? (
            events
              .slice()
              .reverse()
              .map(event => {
                if (event.type === RemittanceEventTypeEnum.PROCESSING) {
                  return (
                    <TimelineNoteRemittanceProcessing
                      date={event.datetime}
                      user={event.user}
                      title={getEventMessage(event, intl)}
                      message={event.message}
                      key={event.id}
                    />
                  );
                }
                if (
                  eventsWithMessage.includes(event.type) &&
                  event.user !== null
                ) {
                  return (
                    <TimelineNote
                      date={event.datetime}
                      user={event.user}
                      message={event.message}
                      key={event.id}
                    />
                  );
                }
                return (
                  <TimelineEvent
                    date={event.datetime}
                    title={getEventMessage(event, intl)}
                    key={event.id}
                  />
                );
              })
          ) : (
            <Skeleton />
          )}
        </Timeline>
      </CardContent>
      <Hr />
    </Card>
  );
};

RemittanceRunnerHistory.displayName = "RemittanceRunnerHistory";
export default RemittanceRunnerHistory;
